import { returnFormattedTime } from '../../util/util'

export const findExpiryChecked = (allValues: any) => {
  if (allValues?.expiry === true) {
    return true
  } else if (typeof allValues?.expiry === 'undefined') {
    return true
  } else {
    return false
  }
}

export const returnCorrectTime = (time: number, type: string) => {
  const isHour = type === 'hour'
  if (isHour) {
    if (Number(time) > 12 || Number(time) === 0) {
      return 12
    } else if (Number(time) < 10) {
      return `0${Number(time)}`
    } else {
      return time
    }
  } else {
    if (Number(time) < 60 && Number(time) > 9) {
      return Number(time)
    } else if (Number(time) < 10) {
      return `0${Number(time)}`
    } else {
      return 59
    }
  }
}

export const timerValue = (
  isHour: boolean,
  isMinute: boolean,
  focused: boolean,
  hour: number,
  minute: number,
  meridian: string,
) => {
  if (!focused) {
    if (isHour) {
      return returnFormattedTime(returnCorrectTime(hour, 'hour'))
    } else if (isMinute) {
      return returnFormattedTime(returnCorrectTime(minute, 'mins'))
    } else {
      return meridian
    }
  } else {
    if (isHour) {
      return hour
    } else if (isMinute) {
      return minute
    } else {
      return meridian
    }
  }
}

export const updateTimeIfWrongInput = (
  hour: number,
  minute: number,
  setHours: (val: number) => void,
  setMinutes: (val: number) => void,
) => {
  if (hour > 12 || hour === 0) {
    setHours(12)
  } else if (minute > 59) {
    setMinutes(59)
  }
}
